import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b3b24f8d51a300140dcd15/nobimed_ai/src/app/not-found.tsx");
